import { Component, ViewChild, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';
import { Overlay, OverlayRef, OverlayConfig } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { ActivatedRoute, Router } from '@angular/router';
import { ZoomService } from 'src/app/services/zoom.service';
import { FunctionsService } from 'src/app/services/functions.service';
import Swal from 'sweetalert2';
import { FormBuilder, Validators } from '@angular/forms';
import { UsuarioService } from 'src/app/services/usuario.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { GeneralService } from 'src/app/services/general.service';
import { VideoWebRtcComponent } from 'src/app/components/video-web-rtc/video-web-rtc.component';
import { DocumentsConsultComponent } from 'src/app/components/documents-consult/documents-consult.component';
import { DocumentsComponent } from 'src/app/components/documents/documents.component';
import { SocketWebRtcService } from 'src/app/services/socket-web-rtc.service';

@Component({
  selector: 'app-videoconsulta-paciente',
  templateUrl: './videoconsulta-paciente.component.html',
  styleUrls: ['./videoconsulta-paciente.component.css']
})
export class VideoconsultaPacienteComponent implements OnDestroy {

  @ViewChild(DocumentsConsultComponent) documentsConsultComponent: DocumentsConsultComponent;
  @ViewChild(DocumentsComponent) documentsComponent: DocumentsComponent;

  @ViewChild('modalInstruccionesTplPaciente', { static: false })
  modalTpl!: TemplateRef<any>;

  @ViewChild(VideoWebRtcComponent) WEB_RTC: VideoWebRtcComponent;

  private overlayRef?: OverlayRef;
  private componenteDestruido = false;

  _title = 'Mi videoconsulta';
  _subtitle = '';
  zoomVideo: any;

  _usuario: any = {};
  chat: boolean = false;

  consulta: any = {};
  idConsulta: number = 0;
  btnIniciar: boolean = false;

  parametros: any;
  datos_consulta: any = {};
  data_cargada = false;
  videoIniciado: any = false;
  device: any = {};

  mostrarModalInstrucciones: boolean = false;
  aceptoInstrucciones: boolean = false;

  options = [false, false];
  options2 = [false, false];

  public info_usuario = this.fb.group({
    use_id: ['', [Validators.required]],
    con_ana_page: ['', [Validators.required]],
    con_ana_connection_type: ['', [Validators.required]],
    con_ana_connection_mode: ['', [Validators.required]]
  });

  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public _usuarioService: UsuarioService,
    private _zoomService: ZoomService,
    private _functions: FunctionsService,
    private _generalServices: GeneralService,
    private router: Router,
    private overlay: Overlay,
    private vcr: ViewContainerRef,
    private web_rtc_socket: SocketWebRtcService
  ) {}

  ngOnInit(): void {
    this.device = this._generalServices.getDevice();
    this._usuario = new EncriptacionService().getUserInfo();

    this.activatedRoute.params.subscribe(parametros => {
      this.parametros = parametros;
      this.idConsulta = parametros.idConsulta;
    });

    this.aceptoInstrucciones = !!localStorage.getItem(
      'ocultarModalInstruccionesPaciente_' + this.idConsulta
    );

    if (this.aceptoInstrucciones) {
      this.continuarLlamada();
    } else {
      this.mostrarModalInstrucciones = true;
      Promise.resolve().then(() => this.abrirModalPaciente());
    }
  }

  ngOnDestroy(): void {
    this.componenteDestruido = true;
    this.cerrarOverlay();
  }

  abrirModalPaciente() {
    if (!this.modalTpl || this.overlayRef) return;

    const config: OverlayConfig = {
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-dark-backdrop',
      panelClass: 'overlay-panel',
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically()
    };

    this.overlayRef = this.overlay.create(config);
    this.overlayRef.attach(new TemplatePortal(this.modalTpl, this.vcr));
  }

  private cerrarOverlay() {
    this.overlayRef?.dispose();
    this.overlayRef = undefined;
  }

  onWebRtcLog(msg: string) {}

  obtenerConsulta(consulta_id) {
    this._zoomService.getConsulta(consulta_id)
      .then(resultado => {
        this.datos_consulta = resultado;

        this.datos_consulta.fecha_consulta = this._functions.formatApptDate(
          new Date(
            this.datos_consulta.fecha_consulta
              .substr(0, 10)
              .replaceAll('-', '/')
          ),
          this.datos_consulta.hora
        );

        this.datos_consulta.dateText = this.datos_consulta.fecha_consulta.text;
        this.datos_consulta.img = '';
        this.data_cargada = true;

        this.iniciarConsulta(resultado);
      })
      .catch(() => {});
  }

  async iniciarConsulta(resultado) {
    await this.sleep(2000);

    if (this.componenteDestruido) return;

    this.videoIniciado = true;
    this.WEB_RTC.joinRoom(resultado);
  }

  sleep(ms = 0) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  optionsButton(index: number) {
    this.options = [false, false];
    this.options2 = [false, false];

    this.options[index] = true;

    if (this.options[0]) {
      this.options2 = [true, false];
    }
  }

  optionsButton2(index: number) {
    this.options2 = [false, false];
    this.options2[index] = true;
  }

  updateDocuments() {
    if (this.documentsComponent) {
      this.documentsComponent.update_doc();
    }
  }

  updateDocuments2() {
    if (this.documentsConsultComponent) {
      this.documentsConsultComponent.update_doc();
    }
  }

  onClickOutside(event: MouseEvent) {}

  continuarLlamada() {
    localStorage.setItem(
      'ocultarModalInstruccionesPaciente_' + this.idConsulta,
      'true'
    );

    this.mostrarModalInstrucciones = false;
    this.cerrarOverlay();

    sessionStorage.setItem('zoom_ud_video', 'true');

    this.observador();

    if (this._usuario.typ_id != 2) {
      Swal.fire({
        icon: 'info',
        title: 'Acceso no autorizado',
        timer: 2000,
        showConfirmButton: false
      });

      setTimeout(() => {
        this.router.navigate(['/dashboard'], {
          replaceUrl: true
        }).then(() => {
          window.location.reload();
        });
      }, 2000);

      return;
    }

    this.activatedRoute.params.subscribe(parametros => {
      this.parametros = parametros;

      this.consulta = {
        med_con_id: parametros.idMedCon
      };

      this.obtenerConsulta(parametros.idConsulta);
    });

    this.registrarInformacionConexion();
  }

  private registrarInformacionConexion() {
    const ua = navigator.userAgent;

    const connectionMode =
      (window.navigator['connection'] as any)?.effectiveType || '';

    let connectionType = 'Desktop';

    if (/iPhone|iPad|iPod/i.test(ua)) {
      connectionType = 'IOS';
    } else if (
      /Android|webOS|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)
    ) {
      connectionType = 'Android';
    }

    this.info_usuario.controls['use_id'].setValue(this._usuario._id);
    this.info_usuario.controls['con_ana_page'].setValue('VideoConsulta');
    this.info_usuario.controls['con_ana_connection_type'].setValue(connectionType);
    this.info_usuario.controls['con_ana_connection_mode'].setValue(connectionMode);

    this._usuarioService.infoUsuario(this.info_usuario.value)
      .subscribe(() => {});
  }

  async observador() {
    while (!this.componenteDestruido) {
      const zoomUdVideo = sessionStorage.getItem('zoom_ud_video');

      if (zoomUdVideo === 'false') {
        (this as any).forcedLeave = true;

        const mediaErr = sessionStorage.getItem('webrtc_media_error');

        if (mediaErr) {
          const accion = await this.mostrarModalErrorMedia(mediaErr);

          this.limpiarErrorMedia();

          if (accion === 'retry') {
            this.reintentarVideollamada();
            return;
          }
        }

        this.salirVideollamada();
        return;
      }

      await this.sleep(1500);
    }
  }

  private async mostrarModalErrorMedia(
    errorCode: string
  ): Promise<'retry' | 'exit'> {

    const contenido = this.obtenerContenidoErrorMedia(errorCode);

    const result = await Swal.fire({
      html: `
        <div class="media-permission-content">

          <div class="media-permission-icon">
            <span class="material-icons">${contenido.icono}</span>
          </div>

          <h2 class="media-permission-title">
            ${contenido.titulo}
          </h2>

          <p class="media-permission-description">
            ${contenido.descripcion}
          </p>

          <div class="media-permission-help">

            <span class="material-icons media-permission-phone">
              phone_in_talk
            </span>

            <div class="media-permission-help-text">
              <strong>¿Sigues con problemas?</strong>

              <span>
                Llama a nuestra Mesa de Ayuda al
                <a href="tel:800248030">800 248 030</a>
                y te ayudamos a resolverlo.
              </span>
            </div>

          </div>

        </div>
      `,
      showCloseButton: true,
      showConfirmButton: true,
      showCancelButton: true,

      confirmButtonText: 'Entendido',
      cancelButtonText: 'Reintentar',

      reverseButtons: true,
      buttonsStyling: false,

      allowOutsideClick: false,
      allowEscapeKey: false,

      customClass: {
        popup: 'swal-media-popup',
        htmlContainer: 'swal-media-html',
        actions: 'swal-media-actions',
        confirmButton: 'swal-media-confirm',
        cancelButton: 'swal-media-retry',
        closeButton: 'swal-media-close'
      }
    });

    if (result.dismiss === Swal.DismissReason.cancel) {
      return 'retry';
    }

    return 'exit';
  }

  private obtenerContenidoErrorMedia(errorCode: string) {
    switch (errorCode) {

      case 'PATIENT_MEDIA_DENIED':
        return {
          icono: 'videocam_off',
          titulo: 'No pudimos acceder a tu cámara y micrófono',
          descripcion:
            'Para ingresar a la videollamada necesitamos tu permiso. Revisa la configuración de tu navegador y actívalos para continuar con tu consulta.'
        };

      case 'PATIENT_MEDIA_BLOCKED':
        return {
          icono: 'videocam_off',
          titulo: 'Tu cámara y micrófono están bloqueados',
          descripcion:
            'Activa los permisos de cámara y micrófono desde la configuración del navegador y luego presiona Reintentar.'
        };

      case 'PATIENT_NO_DEVICE':
        return {
          icono: 'videocam_off',
          titulo: 'No detectamos cámara o micrófono',
          descripcion:
            'Verifica que tu cámara y micrófono estén conectados y disponibles antes de volver a intentarlo.'
        };

      case 'PATIENT_MEDIA_IN_USE':
        return {
          icono: 'videocam_off',
          titulo: 'Tu cámara o micrófono están en uso',
          descripcion:
            'Cierra otras aplicaciones que puedan estar usando tu cámara o micrófono, como Zoom, Meet o Teams, y vuelve a intentarlo.'
        };

      default:
        return {
          icono: 'videocam_off',
          titulo: 'No pudimos acceder a tu cámara y micrófono',
          descripcion:
            'Para ingresar a la videollamada necesitamos acceso a tu cámara y micrófono. Revisa la configuración del navegador y vuelve a intentarlo.'
        };
    }
  }

  private reintentarVideollamada() {
    this.limpiarErrorMedia();

    sessionStorage.setItem(
      'zoom_ud_video',
      'true'
    );

    /*
     * Recargamos la MISMA videoconsulta.
     *
     * Esto es más seguro que crear una segunda conexión WebRTC
     * sobre el componente existente.
     *
     * Además, el modal de instrucciones inicial no vuelve a
     * mostrarse porque ya fue aceptado para esta consulta.
     */
    window.location.reload();
  }

  private limpiarErrorMedia() {
    sessionStorage.removeItem('webrtc_media_error');
    sessionStorage.removeItem('webrtc_media_error_detail');
  }

  private salirVideollamada() {
    this.router.navigate(
      ['/dashboard'],
      {
        replaceUrl: true
      }
    ).then(() => {
      window.location.reload();
    });
  }

  onMediaError(ev: any) {
    const roomName = String(
      this.idConsulta ||
      this.parametros?.idConsulta ||
      ''
    );

    const code =
      ev?.code ||
      ev?.errorCode ||
      'PATIENT_MEDIA_DENIED';

    const detail =
      ev?.detail ||
      ev?.message ||
      '';

    sessionStorage.setItem(
      'webrtc_media_error',
      code
    );

    sessionStorage.setItem(
      'webrtc_media_error_detail',
      detail
    );

    this.web_rtc_socket.socketEmit(
      'webrtcUserStatus',
      {
        roomName,
        userTypeId: 2,
        code,
        detail
      }
    );
  }
}